<template>
  <div
    ref="buzzsproutPlayer"
    class="buzz-sprout-player__wrapper"
    :class="dynamicWrapperClass"
  >
    <div id="buzzsprout-small-player" />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { COOKIE_ENTITY_TYPE } from 'enums/cmp'
import { createCmpHandlerInstance } from 'enums/cmp/cmp-handler'
import * as types from '@/store/mutation-types'
import { isConsentGivenForEntity } from '@/utils/mixins/cmp'

export default {
  name: 'ABuzzSproutPlayer',
  data() {
    return {
      hasConsent: null
    }
  },
  computed: {
    dynamicWrapperClass() {
      return {
        'buzz-sprout-player__wrapper--hidden': this.hasConsent === false
      }
    }
  },
  methods: {
    ...mapMutations({
      removeHandlersForEntityType: `cmp/${types.REMOVE_HANDLERS_FOR_ENTITY_TYPE}`
    }),
    ...mapActions({
      registerHandlerThatRequiresConsent:
        'cmp/registerHandlerThatRequiresConsent'
    }),
    $_buzzSproutPlayer_addScriptToContainer() {
      this.hasConsent = true

      const buzzSproutScript = document.createElement('script')
      buzzSproutScript.type = 'text/javascript'
      buzzSproutScript.charset = 'utf-8'
      buzzSproutScript.src =
        'https://www.buzzsprout.com/2603977.js?artist=&container_id=buzzsprout-small-player&player=small&limit=1'

      if (this.$refs.buzzsproutPlayer) {
        this.$refs.buzzsproutPlayer.appendChild(buzzSproutScript)
      }
    },
    $_buzzSproutPlayer_init() {
      this.removeHandlersForEntityType(COOKIE_ENTITY_TYPE.BUZZ_SPROUT)

      if (!isConsentGivenForEntity(COOKIE_ENTITY_TYPE.BUZZ_SPROUT)) {
        this.hasConsent = false
      }

      this.registerHandlerThatRequiresConsent(
        createCmpHandlerInstance({
          handler: this.$_buzzSproutPlayer_addScriptToContainer,
          entityType: COOKIE_ENTITY_TYPE.BUZZ_SPROUT
        })
      )
    }
  },
  mounted() {
    this.$_buzzSproutPlayer_init()
  }
}
</script>

<style lang="scss" scoped>
.buzz-sprout-player__wrapper {
  min-height: 200px;

  &--hidden {
    display: none;
  }
}
</style>
